export default __webpack_public_path__ + "static/media/element_spec_18.7f28df9c.webp";